import {
  Box,
  BoxProps,
  useTheme,
  Typography,
  LinearProgress,
} from "@mui/material";
import { Icon } from "../Icon";
import { forwardRef } from "react";

/** 저장 공간 진행바 props — `value` 가 100 이상이면 에러 색상으로 강조. */
export interface FileProgressProps extends BoxProps {
  /** 사용량 퍼센트 (0-100). 100 이상이면 에러 표시. */
  value: number;
  showWarningIcon?: boolean;
}

export const FileProgress = forwardRef<HTMLDivElement, FileProgressProps>(
  ({ value, showWarningIcon = true, sx, ...props }, ref) => {
    const theme = useTheme();
    const isFull = value >= 100;
    return (
      <Box ref={ref} sx={{ ...container, ...sx }} {...props}>
        <Box sx={progressContainer}>
          <LinearProgress
            variant="determinate"
            value={isFull ? 100 : value}
            color={!isFull ? "primary" : showWarningIcon ? "error" : "primary"}
          />
        </Box>
        <Box
          sx={[
            textContainer,
            showWarningIcon
              ? { minWidth: "60px" }
              : { minWidth: "40px", justifyContent: "flex-end" },
          ]}
        >
          <Typography variant="body1">{`${Math.floor(
            Math.min(value, 100)
          )}%`}</Typography>
          {showWarningIcon && isFull && (
            <Icon
              size={16}
              padding={0}
              name="etc/ErrorOutline"
              color={
                !isFull ? theme.palette.primary.main : theme.palette.error.main
              }
            />
          )}
        </Box>
      </Box>
    );
  }
);

FileProgress.displayName = "FileProgress";

const container = {
  display: "flex",
  alignItems: "center",
  padding: "0 8px",
  justifyContent: "space-between",
} as const;

const progressContainer = {
  width: "100%",
  mr: 1,
} as const;

const textContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  whiteSpace: "nowrap",
  gap: "4px",
} as const;

export default FileProgress;
